// src/LoginForm.js
import React, { useState } from 'react';

const LoginForm = ({ onLogin, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const success = await onLogin(username, password); // Call the login handler from App.js
    if (!success) {
      setIsLoading(false); // Only reset loading if login explicitly failed and didn't cause a redirect/unmount
    }
    // If login is successful, App.js will typically handle unmounting this form
    // or re-rendering, so setIsLoading(false) might not always be necessary here
    // or could cause a brief flash if unmounted immediately.
    // For simplicity, if onLogin itself handles loading state for the whole app,
    // this local isLoading might just be for the button's visual state.
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      color: '#e2e8f0',
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '16px'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.9) 0%, rgba(51, 65, 85, 0.7) 100%)',
        backdropFilter: 'blur(20px)',
        padding: '40px',
        borderRadius: '24px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        border: '1px solid rgba(148, 163, 184, 0.2)',
        textAlign: 'center',
        width: '100%',
        maxWidth: '400px'
      }}>
        <h1 style={{
          color: '#06b6d4',
          marginBottom: '32px',
          fontSize: 'clamp(1.8rem, 6vw, 2.5rem)',
          fontWeight: '700'
        }}>
          CollarID Access 🐄
        </h1>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div>
            <label htmlFor="username" style={{ display: 'block', marginBottom: '10px', textAlign: 'left', fontSize: '0.9rem', color: '#cbd5e1', fontWeight: '500' }}>Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              style={{
                width: '100%',
                padding: '14px 18px',
                borderRadius: '14px',
                border: '1px solid rgba(148, 163, 184, 0.3)',
                background: 'rgba(30, 41, 59, 0.8)',
                color: '#f1f5f9',
                fontSize: '1rem',
                boxSizing: 'border-box' // Ensures padding doesn't increase total width
              }}
            />
          </div>
          <div>
            <label htmlFor="password" style={{ display: 'block', marginBottom: '10px', textAlign: 'left', fontSize: '0.9rem', color: '#cbd5e1', fontWeight: '500' }}>Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{
                width: '100%',
                padding: '14px 18px',
                borderRadius: '14px',
                border: '1px solid rgba(148, 163, 184, 0.3)',
                background: 'rgba(30, 41, 59, 0.8)',
                color: '#f1f5f9',
                fontSize: '1rem',
                boxSizing: 'border-box'
              }}
            />
          </div>
          {error && <p style={{ color: '#f87171', fontSize: '0.9rem', margin: '-10px 0 10px 0' }}>{error}</p>}
          <button
            type="submit"
            disabled={isLoading}
            style={{
              padding: '16px',
              borderRadius: '14px',
              border: 'none',
              background: isLoading ? '#64748b' : 'linear-gradient(135deg, #06b6d4, #0891b2)',
              color: 'white',
              fontWeight: '600',
              fontSize: '1rem',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'background 0.3s ease, transform 0.2s ease',
              boxShadow: '0 8px 20px rgba(6, 182, 212, 0.25)'
            }}
          >
            {isLoading ? 'Logging In...' : 'Login'}
          </button>
        </form>
      </div>
       <p style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '32px' }}>
        &copy; {new Date().getFullYear()} CollarID Project
      </p>
    </div>
  );
};

export default LoginForm;
